import { collection, addDoc, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebase-config";

/**
 * Build the shared venue payload (used by create + update).
 */
const buildVenuePayload = (venueData) => {
  const { userId, userEmail, lat, lng, images, ...rest } = venueData;
  return {
    ...rest,
    userId,
    userEmail: userEmail || null,
    coordinates: lat && lng ? { lat, lng } : null,
    maxCapacity: rest.maxCapacity ? Number(rest.maxCapacity) : null,
    squareFootage: rest.squareFootage ? Number(rest.squareFootage) : null,
    minPricePerHour: rest.minPricePerHour ? Number(rest.minPricePerHour) : null,
    images: Array.isArray(images) ? images : [],
  };
};

/**
 * Create a new venue doc in the `venues` collection.
 */
export const submitVenueOnboarding = async (venueData) => {
  const payload = buildVenuePayload(venueData);
  const docRef = await addDoc(collection(db, "venues"), {
    ...payload,
    active: false,
    status: "pending_review",
    createdAt: serverTimestamp(),
  });
  return { success: true, venueId: docRef.id };
};

/**
 * Update an existing venue doc. Status/active flags are admin-controlled and
 * explicitly stripped from the payload so the Firestore rules' equality
 * checks against the existing doc trivially pass.
 */
const FORBIDDEN_UPDATE_FIELDS = [
  "status",
  "active",
  "createdAt",
  "id",
  "userId",
];

export const updateVenue = async (venueId, venueData) => {
  const payload = buildVenuePayload(venueData);

  // Remove any field that the user shouldn't be allowed to touch.
  FORBIDDEN_UPDATE_FIELDS.forEach((k) => delete payload[k]);

  await updateDoc(doc(db, "venues", venueId), {
    ...payload,
    updatedAt: serverTimestamp(),
  });
  return { success: true, venueId };
};
